import { render, staticRenderFns } from "./FaseFenologica.vue?vue&type=template&id=89844abc&scoped=true"
import script from "./FaseFenologica.vue?vue&type=script&lang=js"
export * from "./FaseFenologica.vue?vue&type=script&lang=js"
import style0 from "./FaseFenologica.vue?vue&type=style&index=0&id=89844abc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89844abc",
  null
  
)

export default component.exports